import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  SummaryBar as SummaryBarWrap,
  SummaryBarItem,
  SummaryBarDivider,
  SummaryBarDot,
} from '../BuildingDetailsTab.styles'
import {
  classifyBuildings,
  type BuildingData,
} from '../utils/buildingData.utils'

interface SummaryBarProps {
  buildings: BuildingData[]
}

export const SummaryBar: React.FC<SummaryBarProps> = ({ buildings }) => {
  const { t } = useTranslation('land-analysis')
  const { registered, planned, other } = classifyBuildings(buildings)
  const protectedCount = buildings.filter((b) => b.isProtected).length
  const undergroundCount = buildings.filter((b) => b.isUnderground).length

  return (
    <SummaryBarWrap>
      <SummaryBarItem>
        <strong>{buildings.length}</strong>
        {t('buildingDetails.summaryBar.total')}
      </SummaryBarItem>
      <SummaryBarDivider />
      <SummaryBarItem>
        {registered.length} {t('buildingDetails.summaryBar.registered')}
      </SummaryBarItem>
      {planned.length > 0 && (
        <SummaryBarItem>
          <SummaryBarDot $color="#f59e0b" />
          {planned.length} {t('buildingDetails.summaryBar.plannedConstruction')}
        </SummaryBarItem>
      )}
      {other.length > 0 && (
        <SummaryBarItem>
          {other.length} {t('buildingDetails.summaryBar.other')}
        </SummaryBarItem>
      )}
      <SummaryBarDivider />
      {protectedCount > 0 && (
        <SummaryBarItem>
          <SummaryBarDot $color="#ef4444" />
          {protectedCount} {t('buildingDetails.summaryBar.protected')}
        </SummaryBarItem>
      )}
      {undergroundCount > 0 && (
        <SummaryBarItem>
          <SummaryBarDot $color="#6366f1" />
          {undergroundCount} {t('buildingDetails.summaryBar.underground')}
        </SummaryBarItem>
      )}
    </SummaryBarWrap>
  )
}
